import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=01bc0336&"
import script from "./Gallery.vue?vue&type=script&lang=js&"
export * from "./Gallery.vue?vue&type=script&lang=js&"
import style0 from "./Gallery.vue?vue&type=style&index=0&id=01bc0336&prod&lang=css&"
import style1 from "./Gallery.vue?vue&type=style&index=1&id=01bc0336&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports